const DOM = {
  INDEX_TABLE_CONTAINTER: '#remote-jobs-table-container',
  INDEX_TABLE_BODY: 'table.collection#remote-jobs-table tbody',
};

const bindRowClick = function (containerElement) {
  $(containerElement)
    .find(DOM.INDEX_TABLE_BODY)
    .off('click')
    .on('click', function (event) {
      const row = event.target.closest('tr');

      if (row) {
        Turbolinks.visit($(row).attr('href'));
      }
    });
};

const processChannelUpdates = function (remoteJobData) {
  const rowId = `${DOM.INDEX_TABLE_BODY} tr#remote_job_${remoteJobData.id}`;

  if (document.querySelector(rowId) === null) {
    return;
  }

  htmx.ajax('GET', `/${currentCustomer}/remote_jobs/${remoteJobData.id}/row`, {
    target: rowId,
    swap: 'outerHTML swap:0.1s',
  });
};

module.exports = function () {
  const init = new Initializer(),
    remoteJobsChannel = `/${currentCustomer}/remote_jobs`,
    channelSubscriptionId = Messenger.on(
      remoteJobsChannel,
      processChannelUpdates,
    );

  document.addEventListener(
    'turbolinks:before-visit',
    () => {
      if (channelSubscriptionId) {
        Messenger.off(remoteJobsChannel, processChannelUpdates);
      }
    },
    { once: true },
  );

  $(DOM.INDEX_TABLE_CONTAINTER).on('htmx:afterSwap', (event) => {
    init.register();
    bindRowClick(event.target);
  });
};
